import type { RouteObject } from "react-router";
import { Anfrage } from "./Anfrage";
import { AnfrageBearbeiten, AnfrageNeu } from "./AnfrageFormular";
import { Anfragen } from "./Anfragen";
import { AngebotEditor } from "./AngebotEditor";

/** Wege der Anfragen (0072): Pipeline (Liste und Board über ?ansicht=board), anlegen, Detail, bearbeiten, Angebot (neu oder Entwurf). */
export const anfragenRoutes: RouteObject[] = [
  { path: "anfragen", element: <Anfragen /> },
  { path: "anfragen/neu", element: <AnfrageNeu /> },
  { path: "anfragen/:inquiryId", element: <Anfrage /> },
  { path: "anfragen/:inquiryId/bearbeiten", element: <AnfrageBearbeiten /> },
  { path: "anfragen/:inquiryId/angebot/:offerId", element: <AngebotEditor /> },
];
